import { render, staticRenderFns } from "./PromotionsForm.vue?vue&type=template&id=647209e0"
import script from "./PromotionsForm.vue?vue&type=script&lang=js"
export * from "./PromotionsForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionsForm.vue?vue&type=style&index=0&id=647209e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports